export const CREDITOR_NOT_AVAILABLE = 'Not available at this time.';
